import { createSelector } from 'reselect'

export const getData = state => state.reportTransportInvoicing.getIn(['all', 'objects'])
export const createGetDataSelector = () =>
    createSelector(
        [getData],
        data => data
    )

export const isSetTransportPricesInProgress = state => state.reportTransportInvoicing.getIn(['setTransportPrices', 'inProgress'])
export const getSetTransportPricesError = state => state.reportTransportInvoicing.getIn(['setTransportPrices', 'error'])

// Upload transports file

export const getUploadTransportsFileInProgress = state => state.reportTransportInvoicing.getIn(['uploadTransportsFile', 'inProgress'])
export const getUploadTransportsFileError = state => state.reportTransportInvoicing.getIn(['uploadTransportsFile', 'error'])
export const getUploadTransportsFileTransportsIds = state => state.reportTransportInvoicing.getIn(['uploadTransportsFile', 'transportsIds'])